import { useState } from "react";
import { INDICATOR_TYPE_PROCESS, INDICATOR_TYPE_RESULTS, INDICATOR_TYPE_STRUCTURAL } from "../../../../utils/const";
import List from "./List";
import { Indicator } from "../../../../interfaces/IndicatorIndex";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";

const COLOR_BY_TYPE: Record<string, { border: string; bg: string; text: string }> = {
    [INDICATOR_TYPE_STRUCTURAL]: { border: "border-brand-red-10", bg: "bg-brand-red-10", text: "text-brand-red-10" },
    [INDICATOR_TYPE_PROCESS]: { border: "border-brand-green-10", bg: "bg-brand-green-10", text: "text-brand-green-10" },
    [INDICATOR_TYPE_RESULTS]: { border: "border-brand-green-30", bg: "bg-brand-green-30", text: "text-brand-green-30" },
};

const Section = ({ type, items, letter }: { type: string, items: Indicator[], letter: string }) => {
    const [isOpen, setIsOpen] = useState(true);
    const { border, bg, text } = COLOR_BY_TYPE[type];

    return (
        <div className="w-full mb-6">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`flex justify-between w-full mb-2 border-b-2 ${border}`}
            >
                <h2 className={`w-[15.688rem] text-blarge text-primary-100 text-left px-4 py-1 rounded-t-md ${bg}`}>
                    Indicadores {type === INDICATOR_TYPE_RESULTS || type === INDICATOR_TYPE_PROCESS ? 'de' : ''} {type.toLocaleLowerCase()}
                </h2>
                <span className={`w-[1.75rem] h-[1.75rem] ${text}`}>
                    {isOpen ? <MdArrowDropUp size={24} /> : <MdArrowDropDown size={24} />}
                </span>
            </button>
            {isOpen && (
                items.length > 0
                    ? items.map((indicator: Indicator, index) => (
                        <List key={index} indicator={indicator} letter={letter} />
                    ))
                    : <p className="text-blarge text-system-light-100 px-4 py-2">No existen</p>
            )}
        </div>
    );
};

export default Section;